module.exports = __webpack_public_path__ + "static/media/vegetables600.afe63875.jpeg";